<template>
  <EmptyResourceCard
    v-if="showNoActions"
    title="Actions"
    button-text="Add Actions"
    :description="description"
    @button-click="handleAddAction"
  />

  <Card v-else class="mb-0">
    <CardHeader>
      <div class="flex items-center justify-between">
        <CardTitle class="flex items-center gap-2">
          Actions
          <HelpTooltip :description="description" />
        </CardTitle>
        <ResourceLinks />
      </div>
    </CardHeader>
    <CardContent>
      <div class="divide-y divide-border">
        <ActionItem
          v-for="(action, index) in sortedActions"
          :id="`action_item_${index}`"
          :key="action.id"
          :action="action"
          init-mode="view"
        />
      </div>

      <ActionItem
        v-if="showAddAction"
        id="action_item_new"
        class="pt-4 border-t border-dashed"
        init-mode="new"
        @action-added="showAddAction = false"
        @view-mode-enabled="showAddAction = false"
      />
      <div
        v-else
        class="text-blue-700 flex items-center gap-1 cursor-pointer hover:underline mt-2 w-[fit-content]"
        @click="showAddAction = true"
      >
        <vue-feather type="plus-circle" class="w-4" /><span>Add Action</span>
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import EmptyResourceCard from '../common/EmptyResourceCard.vue';
import ActionItem from './ActionItem.vue';
import ResourceLinks from './ResourceLinks.vue';
import { useActionCard } from './useActionCard';
import HelpTooltip from '../common/HelpTooltip.vue';
import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';

const { currentDefinition } = useCurrentWorkflowStore();

const { showAddAction, showNoActions, sortedActions, handleAddAction } = useActionCard();

const description = `An action is something that happens after a ${currentDefinition.trigger.name.toLocaleLowerCase()} trigger occurs.`;
</script>
